import {
  Modal,
  ModalHeader,
  ModalActions,
  ModalContent,
  Text,
  Paper,
  InputWithCounter,
  InputField,
  RadioGroup,
  Space,
} from '@cashfree-intl/coherent';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  & .header .actions {
    background-color: #fff !important;
  }
`;

export const StyledModalHeader = styled(ModalHeader)`
  background-color: white !important;
  min-height: 5rem !important;
`;
export const StyledModalActions = styled(ModalActions)`
  background-color: white !important;
`;
export const StyledModalContent = styled(ModalContent)`
  min-height: 36.875rem !important;
  display: flex !important;
  padding: 0 0 0 2rem !important;
  & > div:nth-child(1) {
    flex-grow: 1;
  }
  & > div:nth-child(2) {
    flex-grow: 3;
    background-color: var(--BACKGROUND_LIGHT) !important;
    padding: 1.5rem;
  }

  & .versions-dropdown {
    width: 26% !important;
  }
`;

export const StyledTimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
`;

export const StyledTimelineIconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  & div {
    flex-grow: 4;
    padding: 0.75rem;
  }
`;

export const StyledHr = styled.hr`
  transform: rotate(90deg) translateY(0.65rem);
  width: 2.5rem;
  height: 0.16rem;
  border-radius: 0.12rem;
  background-color: var(--BACKGROUND_LIGHT);
  border-width: inherit !important;
  &.active {
    background-color: var(--PRIMARY) !important;
  }
`;

export const StyledText = styled(Text)`
  margin-left: 0.5rem;
  color: #a6a7b0;
  &.isActive {
    background-color: var(--BACKGROUND_LIGHT);
    color: var(--SECONDARY_DARK);
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: baseline;
  & div {
    flex: 1;
  }
  & .ui.input {
    margin-bottom: 0 !important;
  }
`;

export const StyledPaper = styled(Paper)`
  padding: 0 !important;

  & .title {
    padding: 1.2rem !important;
  }
  & .content {
    padding: 0 1.2rem 1.2rem 1.2rem !important;
  }
  & .content .accordion.ui > div:nth-child(2) {
    background-color: white !important;
  }
  & .content .accordion.ui > div {
    padding-left: 0 !important;
  }

  & .ui.radio.checkbox input:checked ~ label::after {
    background-color: rgb(105, 48, 202) !important;
    top: 1px !important;
  }
  & .content .accordion.ui .accordion > div:nth-child(3) {
    padding: 0 !important;
    padding-left: 0.5rem !important;
    padding-top: 0.3rem !important;
  }
  & .title.active {
    padding: 1rem 1rem 0.6rem 1rem !important;
  }
  & .content .ui.selection.dropdown {
    min-width: 10.5rem !important;
  }
`;

export const StyledHorizontalLine = styled.hr`
  width: 104%;
  transform: translateX(-1.1rem);
  background-color: #e6e5e8;
`;

export const StyledContentWrapper = styled.div`
  width: 50rem;
`;

export const StyledInputWithCounter = styled(InputWithCounter)`
  max-width: 6.875rem;
  /* margin-top: 0.5rem; */
  & ~ div {
    bottom: 1.875rem;
  }
`;

export const StyledRetriesWrapper = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: baseline;
  & .ui.selection.dropdown {
    font-size: 0.9rem !important;
    height: 2.525rem !important;
  }
`;

export const StyledInputField = styled(InputField)`
  & input {
    max-width: 3.125rem !important;
  }
`;

export const StyledChipWrapper = styled.div`
  & .events-chip {
    display: inline-block;
    background-color: var(--TABLE_COLUMN);
    padding: $pix-4 0;
    border-radius: $pix-2;
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  & .ui.checked.checkbox label::before {
    border: 2px solid rgb(105, 48, 202) !important;
  }
  & input:checked ~ label::after {
    background-color: rgb(105, 48, 202) !important;
    top: 1px !important;
  }
`;

export const StyledSummaryPaper = styled(Paper)`
  padding: 1rem !important;
`;

export const StyledRetryMessage = styled(Text)`
  padding: 0.625rem 0.75rem 0.625rem 0.75rem;
  border-radius: 0.5rem;
  background: #efe5ff;
  color: var(--PRIMARY);
  margin-top: 0.5rem;
`;

export const StyledChip = styled(Text)`
  padding: 0.125rem 0.375rem 0.125rem 0.375rem;
  background: #f9ecda;
  color: #d68309;
  margin-left: 0.5rem;
`;

export const StyledSpace = styled(Space)`
  & div:nth-child(2) {
    flex-shrink: 20;
  }
  & div:nth-child(1) {
    flex-shrink: 0;
  }
`;

export const StyledProgressBar = styled.div`
  border: 2px solid #a6a7b0;
  border-radius: 2px;
  position: relative;
`;

export const StyledProgressCircle = styled.div<any>`
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #a6a7b0;
  transform: translateY(-6px);
  left: ${props => props.left}%;
`;

export const StyledWrappedText = styled(Text)`
  white-space: break-spaces;
`;

export const StyledEndpointText = styled(Text)`
  width: 20%;
`;

export const StyledInputVersion = styled(InputField)`
  width: 25%;
`;

export const StyledWebhookSpace = styled(Space)`
  cursor: pointer;
`;

export const SummaryStyledInputWrapper = styled.div`
  position: relative;
  display: flex;
  column-gap: 1rem;
  align-items: baseline;
  & div {
    flex: 1;
  }
  & .ui.input {
    margin-bottom: 0 !important;
  }
`;

export const StyledCopyToClipboard = styled.div`
  position: absolute;
  right: 11.5rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
`;
